const proFile = {
  state: {
    proFileId: 0,
    timestampInfor: 0,
    proFileBabyId: 0
  },
  getters: {
    proFileId: state => {
      return state.proFileId
    },
    timestampInfor: state => {
      return state.timestampInfor
    },
    proFileBabyId: state => {
      return state.proFileBabyId
    }
  },
  mutations: {
    SET_PRO_FILE_ID (state, proFileId) {
      state.proFileId = proFileId
    },
    SET_TIME (state, timestampInfor) {
      state.timestampInfor = timestampInfor
    },
    SET_PRO_FILE_BABY_ID (state, proFileBabyId) {
      state.proFileBabyId = proFileBabyId
    }
  },
  actions: {}
}

export default proFile



// WEBPACK FOOTER //
// ./src/store/modules/proFile.js